import { CALENDAR_SPOT_INFO, ENTRY_BY_TYPE } from '@/calendar-types'
import { CustomWindow } from '@/types'

declare const window: CustomWindow

export function handleLinkClick(url: string, target?: string) {
  if (window?.webkit?.messageHandlers?.calendarLinkHandler) {
    window.webkit.messageHandlers.calendarLinkHandler.postMessage(url)
    return
  }

  window.open(url, target ?? '_blank')
}

export function findDifferences(obj1: any, obj2: any) {
  const diffs: Record<string, { oldValue: any; newValue: any }> = {}

  for (const key in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj1, key)) {
      if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
        diffs[key] = { oldValue: obj1[key], newValue: obj2[key] }
      }
    }
  }
  // Also check for any keys in obj2 that are missing in obj1
  for (const key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, key) && !(key in obj1)) {
      diffs[key] = { oldValue: undefined, newValue: obj2[key] }
    }
  }

  return diffs
}

export function stripDomainAndProtocol(url: string) {
  const parts = url.split('/')
  return '/' + parts.slice(3).join('/')
}

export function getCtaLink(
  type: string,
  store: ReturnType<typeof useCalendarStore>,
) {
  if (!store?.spotInfo?.cta_links) return
  const ctaLink = store.spotInfo.cta_links.find(
    (ctaLink) => ctaLink.cta_link_type === type,
  )

  if (!ctaLink) return

  return ctaLink.url
}

export function removeFollowerCount(value: string) {
  return value
    .replace(/(\s*)<[^>]*>\d+<\/[^>]*>(\s*)|(\b\d+\b)(\s*)/g, ' ')
    .trim()
}
